<template>
  <v-card ripple>
    <span>
      <v-toolbar dense
                 fixed>
        <v-btn router
               flat
               to="/viewfreight"
               class="teal--text darken-2">Kangaruu</v-btn>
        <v-spacer></v-spacer>

        <v-btn class="teal--text darken-2"
               small
               router
               flat
               icon
               v-on:click="logout">
          <v-icon>exit_to_app</v-icon>
        </v-btn>

        <v-btn v-if="isShipper"
               small
               flat
               icon
               router
               color="teal"
               to="/brokers">
          <v-icon>account_circle</v-icon>
        </v-btn>

        <v-btn v-if="isBroker"
               small
               flat
               icon
               router
               color="teal"
               @click.native="showShippers()">
          <v-icon>account_circle</v-icon>
        </v-btn>

        <v-btn v-if="isShipper"
               small
               flat
               icon
               router
               color="teal"
               to="/freight">
          <v-icon>add</v-icon>
        </v-btn>

        <v-btn small
               flat
               icon
               router
               color="teal"
               @click.native="settings = true">
          <v-icon>settings</v-icon>
        </v-btn>

        <v-btn small
               flat
               icon
               router
               color="teal"
               @click.native="showFreightSearch = true">
          <v-icon>search</v-icon>
        </v-btn>

        <v-btn small
               flat
               icon
               router
               color="teal"
               @click.native="showHelp = true">
          <v-icon>help</v-icon>
        </v-btn>

      </v-toolbar>
    </span>

    <v-dialog v-model="showHelp">
      <v-card>
        <help></help>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey"
                 flat
                 outline
                 @click.native="showHelp = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFreightSearch"
              max-width="400">
      <v-card>
        <freight-search :id="brokerID"
                        :isBroker="isBroker"
                        v-on:cargo="toggle"></freight-search>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1"
                 flat
                 @click.native="showFreightSearch = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="settings"
              max-width="400">

      <v-card>
        <v-card-title>
          <span class="headline">User Settings</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="mobile"
                              label="Mobile Number"
                              :rules="phoneRules"
                              hint="Get Text alerts when there is a new shipment"
                              persistent-hint>
                  {{mobile}}
                </v-text-field>
                <br>
                <v-switch v-model="txt"
                          label="Send Text Notifications"></v-switch>
                <v-switch v-model="receipt"
                          label="Send Conformation Email"></v-switch>
                <v-switch v-model="push"
                          v-on:click.native="enablePush()"
                          label="Send Push Notifications"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1"
                 flat
                 @click.native="settings = false">Cancel</v-btn>
          <v-btn color="blue darken-1"
                 flat
                 @click.native="updatePhone()">Update</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-layout row
              wrap
              v-if="!Object.keys(shipments).length && isShipper">
      <v-flex>
        <v-card>
          <v-card-text class="blue--text darken-4">
            No Open Shipments, Invite your Brokers
            <v-icon>account_circle</v-icon>and create a shipment
            <v-icon>add</v-icon> from the toolbar.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              wrap
              v-if="!Object.keys(shipments).length && isBroker">
      <v-flex>
        <v-card>
          <v-card-text class="blue--text darken-4">
            No Open Shipments. Invite your Shippers
            <v-icon>account_circle</v-icon> to use Kangaruu from the toolbar.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-list two-line
            v-for="(shipment) in shipments"
            :key="shipment.id">
      <v-list-tile ripple
                   @click="toggle(shipment.id)">
        <v-list-tile-content>
          <v-list-tile-title class="blue--text darken-4">
            <span v-for="(msg, key, index) in shipment.newMessages"
                  :key="index">
              <v-icon class="red--text darken-4"
                      v-if="userID === key && msg === true">fiber_new</v-icon>
            </span>
            <span v-for="(selected, key) in shipment.isSelected"
                  :key="key">
              <v-icon class="blue--text darken-4"
                      v-if="userID === key && selected === true">check_circle</v-icon>
            </span>
            {{shipment.Delivery[shipment.Delivery.length - 1]}}
          </v-list-tile-title>

          <v-list-tile-sub-title class="orange--text darken-4">
            {{shipment.PickupDate}} -
            <span class="black--text">{{shipment.Equipment}}</span>
          </v-list-tile-sub-title>

          <v-list-tile-action-text class="teal--text darken-4">
            <broker-name :brokerID="shipment.Shipper"></broker-name>
            - {{shipment.Reference}}
          </v-list-tile-action-text>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>

<script>
import db from './fireBaseInit'
import Firebase from 'firebase'
import toolbar from '@/components/ToolBar'
import brokertoolbar from '@/components/BrokerToolBar'
import brokerName from '@/components/BrokerName'
import freightSearch from '@/components/FreightSearch'
import help from '@/components/InboxHelp'

export default {
  name: 'viewfreight',
  components: { toolbar, brokertoolbar, brokerName, freightSearch, help },
  data () {
    return {
      shippingFreight: [],
      brokerFreight: [],
      shipments: [],
      show: false,
      selected: [2],
      isBroker: false,
      isShipper: true,
      receipt: false,
      mobile: '',
      txt: false,
      push: false,
      UserID: null,
      user: {},
      settings: false,
      showHelp: false,
      brokerID: '',
      showFreightSearch: false,
      dot: '/static/blueDot.png',
      phoneRules: [
        v => /^$|^(\+\d{1,4})?[\s-]?\(?(\d{3})\)?[\s-]?\d{3}[\s-]?\d{4}/.test(v) || 'Mobile number must be valid'
      ]
    }
  },
  firestore () {
    return {
    }
  },
  mounted: function () {
    this.$bind('user', db.collection('users').doc(Firebase.auth().currentUser.uid))
      .then((doc) => {
        this.mobile = this.user.mobile
        this.push = this.user.sendPush
        this.receipt = this.user.sendReceipt
        this.txt = this.user.sendSMS
        this.userID = Firebase.auth().currentUser.uid
        if (this.user.isBroker) {
          this.isBroker = true
          this.isShipper = false
          this.brokerID = Firebase.auth().currentUser.uid
          this.$bind('shipments', db.collection('freight')
            .where(`brokers.${Firebase.auth().currentUser.uid}`, '==', true)
            .where('isActive', '==', true))
        } else {
          // brokerID generic for all id's
          this.brokerID = Firebase.auth().currentUser.uid
          this.isBroker = false
          this.isShipper = true
          this.$bind('shipments', db.collection('freight')
            .where('Shipper', '==', Firebase.auth().currentUser.uid)
            .where('isActive', '==', true))
        }
      })
  },
  methods: {
    enablePush () {
      if (!this.user.sendPush) {
        const messaging = Firebase.messaging()
        messaging.usePublicVapidKey('BCAgktL2vpb0hNNKITygLDrNcS3YwVk28-oRtw4tmU4Qm7G65nmJ1zHOX78ktmxfLQLEeRSvb03u0FpVW_QNgn8')

        messaging.requestPermission().then(function () {
          console.log('Notification permission granted.')
          messaging
            .getToken()
            .then(function (currentToken) {
              if (currentToken) {
                console.log(currentToken)
                var update = {}
                update['token'] = currentToken
                db.collection('users').doc(Firebase.auth().currentUser.uid).update(update)
                // sendTokenToServer(currentToken)
                // updateUIForPushEnabled(currentToken)
              } else {
                // Show permission request.
                console.log(
                  'No Instance ID token available. Request permission to generate one.'
                )
                // Show permission UI.
                // updateUIForPushPermissionRequired()
                // setTokenSentToServer(false)
              }
            })
            .catch(function (err) {
              console.log('An error occurred while retrieving token. ', err)
              // showToken('Error retrieving Instance ID token. ', err)
              // setTokenSentToServer(false)
            })
        }).catch(function (err) {
          console.log('Unable to get permission to notify.', err)
        })
      } else {
        // Remove the token from firebaes
        db.collection('users').doc(Firebase.auth().currentUser.uid).update({ token: null })
      }
    },
    updatePhone () {
      this.settings = false
      var update = {}
      update['mobile'] = this.mobile
      update['sendPush'] = this.push
      update['sendReceipt'] = this.receipt
      update['sendSMS'] = this.txt
      db.collection('users').doc(Firebase.auth().currentUser.uid).update(update)
    },
    toggle (index) {
      if (!this.isBroker) {
        // this.$router.push('freight' + '/' + index)
        this.$router.push({ name: 'shipperfreight', params: { shipmentID: index } })
      } else {
        // this.$router.push('brokerfreight' + '/' + index)
        this.$router.push({ name: 'brokerfreight', params: { shipmentID: index, brokerID: this.brokerID } })
      }
    },
    showShippers: function () {
      console.log(this.brokerID)
      this.$router.push({ name: 'shippers', params: { brokerID: this.brokerID } })
    },
    logout: function () {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    }
  },
  watch: {
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ViewFreight.vue